import {Injectable} from '@angular/core';
import {Backend} from '@generated-backend-types';
import {BaseEndpointService} from '../base-endpoint-service';
import PublicHoliday = Backend.App.Resources.Dashboard.TimeTracking.PublicHoliday;

@Injectable({providedIn: 'root'})
export class PublicHolidayService extends BaseEndpointService<PublicHoliday> {
  protected override endpoint = '/time-tracking/public-holidays';
  protected override multiSelectTextFields = ['name'] as const;
}
